import { createAction } from '@reduxjs/toolkit';

import type { LiveUpdatesEntities, LiveUpdatesEntity } from '../../types/state.types';

export const updateUpdatedPipes = createAction<{ pipes: LiveUpdatesEntities }>(
  'liveUpdates/updatedPipes'
);

export const updateUpdatedSystems = createAction<{ systems: LiveUpdatesEntities }>(
  'liveUpdates/updatedSystems'
);

export const updateUpdatedDatasets = createAction<{ datasets: LiveUpdatesEntities }>(
  'liveUpdates/updatedDatasets'
);

export const updateDeletedPipes = createAction<{ pipes: LiveUpdatesEntities }>(
  'liveUpdates/deletedPipes'
);

export const removeDeletedPipe = createAction<LiveUpdatesEntity>('liveUpdates/removeDeletedPipe');

export const updateDeletedSystems = createAction<{ systems: LiveUpdatesEntities }>(
  'liveUpdates/deletedSystems'
);

export const removeDeletedSystem = createAction<LiveUpdatesEntity>(
  'liveUpdates/removeDeletedSystem'
);

export const updateDeletedDatasets = createAction<{ datasets: LiveUpdatesEntities }>(
  'liveUpdates/deletedDatasets'
);
